<template>
  <div>
    <vs-popup :active.sync="activeLocal" :title="title" class="formula-popup">
      <div class="formula">
        <div class="flex flex-col items-center justify-center">
          <div class="formula__button-constant button-constant">
            <span class="button-constant__text">
              Значение тарифа
            </span>
          </div>
          <div class="formula__item formula__operator" data-value="*">*</div>
        </div>
        <div ref="formula" class="formula__wrapper">
          <div class="formula__alert"
               :class="[{'formula__alert_good': isValid === true, 'formula__alert_error': isValid === false}]">
            {{isValid === true ? 'Формула корректна': isValid === false ? 'Формула не корректна' : 'Формула'}}
          </div>
          <div class="formula__container" v-html="formulaHTML">
          </div>

          <textarea @keydown="keyDown" class="formula__text" ref="formulaText" @focus="isFocus=true"
                    @blur="isFocus = false"></textarea>
        </div>
        <div v-show="isDivisionInFormula" class="formula_division_zero">
          Учитывайте, что при делении на 0 начисление не будет произведено
        </div>
        <div class="formula__buttons flex" v-if="$can('rp.tariffs', 'write')">

          <div class="pr-4">
            <div class="flex items-center">
              <div class="formula__number-buttons">
            <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('7')">7</span>
            </span>
                <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('8')">8</span>
            </span>
                <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('9')">9</span>
            </span>
              </div>

              <div class="formula__operator-buttons">
             <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('+')">+</span>
            </span>
                <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('-')">-</span>
            </span>
              </div>

            </div>
            <div class="flex items-center">
              <div class="formula__number-buttons">
            <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('4')">4</span>
            </span>
                <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('5')">5</span>
            </span>
                <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('6')">6</span>
            </span>
              </div>

              <div class="formula__operator-buttons">
           <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('*')">*</span>
            </span>
                <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('/')">/</span>
            </span>
              </div>
            </div>
            <div class="flex items-center">
              <div class="formula__number-buttons">
                <div class="formula__number-buttons">
            <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('1')">1</span>
            </span>
                  <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('2')">2</span>
            </span>
                  <span class="formula__button formula-button">
                <span class="formula-button__text" @click="updateFormulaText('3')">3</span>
              </span>
                </div>
              </div>

              <div class="formula__operator-buttons">
            <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText('(')">(</span>
            </span>
                <span class="formula__button formula-button">
              <span class="formula-button__text" @click="updateFormulaText(')')">)</span>
            </span>
              </div>
            </div>
            <div class="flex items-center">
              <div class="formula__number-buttons">
           <span class="formula__button formula-button formula-button_zero">
              <span class="formula-button__text" @click="updateFormulaText('0')">0</span>
            </span>
              </div>
              <div class="formula__operator-buttons">
            <span class="formula__button formula-button formula-button_comma">
              <span class="formula-button__text"
                    @click="updateFormulaText(NUMBER_DELIMITER)">{{NUMBER_DELIMITER}}</span>
            </span>
              </div>
            </div>
          </div>
          <div class="relative">
            <div class="w-full flex items-center justify-between mb-4">
              <h5 class="">Константы</h5>
              <span @click.prevent.stop="openEditConstant" >
                <feather-icon icon="EditIcon" :svg-classes="['text-primary', 'cursor-pointer']" />
              </span>
            </div>

            <vs-collapse accordion class="constants-collapse">
              <vs-collapse-item v-for="group in constantsInGroups" :key="group.id">
                <div slot="header">
                  {{group.name}}
                </div>
                <span class="formula__button-constant button-constant" v-for="block in group.constants"
                      :key="`constant-${block.code}`" @click="updateFormulaText(block.code, true)">
                  <span class="button-constant__text">
                    {{block.name}}
                  </span>
                </span>
              </vs-collapse-item>
            </vs-collapse>

          </div>

        </div>
      </div>
      <div class="text-center mt-8" v-if="$can('rp.tariffs', 'write')">
        <vs-button @click="activeLocal = false" type="flat" class="mr-4">Отменить</vs-button>
        <vs-button @click="saveFormula" color="success">Применить</vs-button>
      </div>
      <vs-popup :active.sync="isEditConstantsOpen" title="Редактирование констант" ref="editConstantPopup" class="edit-constant-popup">
        <div class="flex w-full justify-center">
          <div class="mb-base">
            <label class="vs-input--label">Месяц:</label>
            <datepicker v-model="editConstantsMonth"
                        format="MMMM yyyy"
                        minimumView="month"
                        maximumView="year"
                        class="w-full"
            />
          </div>

        </div>
        <div class="vx-row" ref="editConstantPopupRow">
          <template v-if="editConstants.length">
            <div class="vx-col w-full pb-3 flex flex-wrap justify-between" v-for="(constant, index) in editConstants"
                 :key="`edit-constant-${index}`">

              <div class="pb-base pr-2 flex-1">
                <label class="vs-input--label">Название константы:</label>
                <v-select @search:focus="focusSelect" ref="vSelect" taggable push-tags :options="editConstantsAll" :value="constant.name" @input="setExistingValue($event, constant)" label="name"
                          class="flex-1 edit-constant__name-select"  :create-option="constant => ({ name: constant })">
                  <div slot="no-options">Констант нет!</div>
                </v-select>
              </div>
<!--              <vs-input label="Название константы" class="pb-base pr-2 flex-1" v-model.trim="constant.name"-->
<!--                        :danger="constant.errors.name" danger-text="Введите имя" @input="constant.errors.name = false"-->
<!--                        :disabled="!$can('rp.tariffs', 'write')"/>-->
              <vs-input label="Короткое название" class="pb-base pr-2 flex-1" v-model.trim="constant.short_name"
                        :danger="constant.errors.short_name" danger-text="Введите короткое имя" @input="constant.errors.short_name = false"
                        :disabled="!$can('rp.tariffs', 'write')"/>
              <vs-input label="Значение" class="pb-base pr-2 flex-1" v-model="constant.value"
                        :danger="constant.errors.value" danger-text="Введите корректное значение" @input="constant.errors.value = false"
                        :disabled="!$can('rp.tariffs', 'write')" type="number"/>
              <vs-button type="flat" size="large" icon-pack="feather" class="mt-5" icon="icon-trash" color="danger"
                         v-if="$can('rp.tariffs', 'write')"
                         @click="deleteEditConstant(index, constant)"/>
            </div>
          </template>
          <h5 v-else class="text-center w-full mb-4">Индивидуальных констант нет</h5>

          <div class="vx-col w-full flex justify-center">
            <vs-button type="flat" class="mr-2" @click="addNewConstant" v-if="$can('rp.tariffs', 'write')">
              Добавить
            </vs-button>
            <vs-button type="filled" color="success" @click="saveConstants" v-if="$can('rp.tariffs', 'write')">
              Сохранить
            </vs-button>
          </div>
        </div>
      </vs-popup>

    </vs-popup>

  </div>

</template>

<script>
  import {convert, valid} from "metric-parser";

  const OPERATORS = ['+', '*', '/', '-'];
  const BRACKETS = ['(', ')'];
  const NUMBER_DELIMITER = ',';

  export default {
    name: "FormulaPopup",
    props: {
      active: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      formula: {
        required: true
      },
      constants: {
        required: true,
      },
      groups: {
        default: () => ([])
      }
    },
    data() {
      return {
        OPERATORS: OPERATORS,
        BRACKETS: BRACKETS,
        NUMBER_DELIMITER: NUMBER_DELIMITER,
        ALLOWED_CHARS: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', NUMBER_DELIMITER, ...OPERATORS, ...BRACKETS],
        cursorIndex: 0,
        formulaData: [],
        isFocus: false,
        isEditConstantsOpen: false,
        editConstants: [],
        editConstantsBackup: [],
        deleteConstantsArray: [],
        editConstantsMonth: new Date(),
        editConstantsAll: [],
      }
    },
    computed: {
      selectedHouseId() {
        return this.$store.getters['appUser/selectedHouse'].id;
      },
      activeLocal: {
        get() {
          return this.active;
        },
        set(value) {
          this.$emit('update:active', value);
        }
      },
      formulaHTML() {
        let html = '';
        this.formattedFormulaData.forEach((elem, index) => {
          if (index === this.cursorIndex && this.isFocus && this.$can('rp.tariffs', 'write')) {
            html += this.getFormulaCursor();
          }
          if (elem.type === 'bracket') {
            html += this.getFormulaBracket(elem.name, elem.value);
          } else if (elem.type === 'operator') {
            html += this.getFormulaOperator(elem.name, elem.value);
          } else if (elem.type === 'unit' || elem.type === 'constant') {
            html += this.getFormulaUnit(elem.name, elem.value);
          }
        });
        if (this.cursorIndex === this.formattedFormulaData.length && this.isFocus && this.$can('rp.tariffs', 'write')) {
          html += this.getFormulaCursor();
        }
        return html;
      },
      formattedFormulaData() {
        return this.formatFormulaData(this.formulaData);
      },
      isDivisionInFormula() {
        return this.formulaData.indexOf('/') !== -1;
      },
      isValid() {
        if (this.formulaData.length === 0) return null;

        let isValid = true;

        let prevElem = '';

        let formulaData = this.formulaData.map(op => {
          if (this.isNumber(op) && op < 0) return '(0' + Number(op) + ')';
          return op;
        });

        formulaData.forEach((data) => {
          if (this.isNumber(data) && this.isNumber(prevElem)) {
            isValid = false;
          }
          prevElem = data;
        });

        if (!isValid) return false;

        let formula = formulaData.join('');
        return valid(formula);
      },
      constantsInGroups(){
        let constantsInGroups = {};

        this.groups.forEach(group => {
          if(!constantsInGroups[group.id]){
            constantsInGroups[group.id] = {
              id: group.id,
              name: group.name,
              constants: []
            }
          }
          constantsInGroups[group.id].constants = constantsInGroups[group.id].constants.concat(this.constants.filter(constant => constant.types_id === group.id));
        });
        constantsInGroups = Object.values(constantsInGroups);
        return constantsInGroups;
      }
    },
    methods: {
      updateFormulaText(key, constant = false) {

        this.$refs.formulaText.focus();

        if (key === 'ArrowLeft') {
          if (this.cursorIndex - 1 >= 0) {
            this.cursorIndex -= 1;
          }
          return;
        }

        if (key === 'ArrowRight') {
          if (this.cursorIndex + 1 < this.formulaData.length + 1) {
            this.cursorIndex += 1;
          }
          return;
        }

        let updatePrevElement = (key) => {
          this.formulaData.splice(this.cursorIndex - 1, 1, '' + this.formulaData[this.cursorIndex - 1] + key);
        };

        let deleteElem = () => {
          if (this.cursorIndex - 1 >= 0) {
            this.formulaData.splice(this.cursorIndex - 1, 1);
            this.cursorIndex -= 1;
          }
        };

        let addElem = (key) => {
          this.formulaData.splice(this.cursorIndex, 0, key);
          this.cursorIndex += 1;
        };

        if (key === 'Backspace') {
          deleteElem();
          return;
        }

        if (constant) {
          addElem(key);
          return;
        }

        if (this.ALLOWED_CHARS.findIndex(char => char === key) !== -1) {
          let prevElement = this.cursorIndex - 1 >= 0 ? this.formattedFormulaData[this.cursorIndex - 1] : '';
          let prevPrevElement = this.cursorIndex - 2 >= 1 ? this.formattedFormulaData[this.cursorIndex - 2] : '';

          if (this.isNumber(key)) {
            if (this.isNumber(prevElement.constant) || this.isNumberDelimiter(prevElement[prevElement.length ? prevElement.length - 1 : 0])) {
              updatePrevElement(key);
              return;
            } else if (prevPrevElement && (this.isBracket(prevPrevElement.constant) || this.isOperator(prevPrevElement.constant)) && prevElement && prevElement.constant === '-') {
              updatePrevElement(key);
              return;
            } else {
              addElem(key);
              return;
            }
          }

          if (this.isNumberDelimiter(key)) {
            if (this.isNumber(prevElement.constant) && prevElement.constant.indexOf('.') === -1) {
              updatePrevElement('.');
              return;
            } else {
              return;
            }
          }

          addElem(key);
        } else {
          return;
        }


      },
      keyDown(event) {
        if (!this.$can('rp.tariffs', 'write')) return false;

        let key = event.key;
        this.updateFormulaText(key);
      },
      getConstant(elem) {
        let constant = this.constants.find(block => block.code === elem);
        return constant;
      },
      isConstant(elem) {
        let constant = this.constants.findIndex(block => block.code === elem);
        return constant !== -1;
      },
      isBracket(elem) {
        let constant = this.BRACKETS.findIndex(block => block === elem);
        return constant !== -1;
      },
      isOperator(elem) {
        let isOperator = this.OPERATORS.findIndex(operator => operator === elem);
        return isOperator !== -1;
      },
      isNumberDelimiter(elem) {
        return elem === this.NUMBER_DELIMITER;
      },
      isNumber(elem) {
        return !isNaN(elem) && elem !== '';
      },
      getFormulaItem(text, value) {
        let span = document.createElement('span');
        span.className = 'formula__item';
        span.innerHTML = text;
        span.dataset.value = value === undefined ? text : value;
        return span;
      },
      getFormulaUnit(text, value) {
        let span = this.getFormulaItem(text, value);
        span.classList.add('formula__unit');
        return span.outerHTML;
      },
      getFormulaOperator(text, value) {
        let span = this.getFormulaItem(text, value);
        span.classList.add('formula__operator');
        return span.outerHTML;
      },
      getFormulaBracket(text, value) {
        let span = this.getFormulaItem(text, value);
        span.classList.add('formula__bracket');
        return span.outerHTML;
      },
      getFormulaCursor() {
        let span = document.createElement('span');
        span.classList.add('formula__cursor');
        return span.outerHTML;
      },
      parseFormula(formulaObj) {
        formulaObj = typeof formulaObj === 'string' ? JSON.parse(formulaObj) : {};

        let formulize = convert(formulaObj);

        if (formulize.code !== 0) return [];

        if (formulize.data.findIndex(op => op === undefined) !== -1) {
          do {
            let indx = formulize.data.findIndex(op => op === undefined);
            if (formulize.data[indx + 1] === '-' && this.isNumber(formulize.data[indx + 2])) {
              let nmbr = formulize.data[indx + 2] * -1;

              formulize.data.splice(indx, 3, nmbr);

            } else {
              formulize.data.splice(indx, 1, 0);
            }
          } while (formulize.data.findIndex(op => op === undefined) !== -1)
        }

        return formulize.data;
      },
      async saveFormula() {
        let formulaData = this.formulaData.map(op => {
          if (this.isNumber(op) && op < 0) return '(0' + Number(op) + ')';
          return op;
        });

        let string = formulaData.join('');
        string = convert(string);

        if (string.code === 0) {
          this.$emit('update:formula', JSON.stringify(string.data));
          this.$emit('saveFormula', JSON.stringify(string.data));
          this.activeLocal = false;
        }


      },
      getHtml(formula, isShortName = false, cursor = false) {
        let html = '';
        let formattedFormulaData = this.formatFormulaData(this.parseFormula(formula));
        formattedFormulaData.forEach((elem, index) => {
          if (index === this.cursorIndex && this.isFocus && cursor) {
            html += this.getFormulaCursor();
          }
          if (elem.type === 'bracket') {
            html += this.getFormulaBracket(elem.name, elem.value);
          } else if (elem.type === 'operator') {
            html += this.getFormulaOperator(elem.name, elem.value);
          } else if (elem.type === 'unit' || elem.type === 'constant') {
            html += this.getFormulaUnit(isShortName ? elem.short_name : elem.name, elem.value);
          }
        });
        if (this.cursorIndex === this.formattedFormulaData.length && this.isFocus && cursor) {
          html += this.getFormulaCursor();
        }
        return html;
      },
      formatFormulaData(data) {
        let formattedData = [];
        data.forEach(op => {
          let elem;
          if (this.isBracket(op)) {
            elem = {
              value: op,
              constant: op,
              name: op,
              short_name: op,
              type: 'bracket',
            };
          } else if (this.isOperator(op)) {
            elem = {
              value: op,
              constant: op,
              name: op,
              short_name: op,
              type: 'operator',
            };
          } else if (this.isConstant(op)) {
            let constant = this.getConstant(op);
            elem = {
              value: constant.code,
              constant: constant.code,
              short_name: constant.short_name,
              name: constant.name,
              type: 'constant',
            };
          } else {
            op = op.toString();
            let isLastCharIsDot = op.length ? op.slice(-1) === '.' : false;
            elem = {
              value: op,
              constant: op,
              name: !this.isNumber(op) || isLastCharIsDot || (Number(String(op)[String(op).length - 1]) === 0) ? op : this.$options.filters.numberWithSpaces(Number(op), ','),
              short_name: !this.isNumber(op) || isLastCharIsDot || (Number(String(op)[String(op).length - 1]) === 0) ? op : this.$options.filters.numberWithSpaces(Number(op), ','),
              type: 'unit',
            };
          }

          formattedData.push(elem);
        });
        return formattedData;
      },
      updateFormula() {
        this.formulaData = this.parseFormula(this.formula);
        this.cursorIndex = this.formulaData.length;
      },

      openEditConstant() {
        this.deleteConstantsArray = [];
        let selectedMonth = this.$options.filters.moment(this.editConstantsMonth, 'YYYY-MM');
        this.editConstants = JSON.parse(JSON.stringify(this.constants.filter(constant => [3,5].includes(constant.types_id) && Object.keys(constant.values).includes(selectedMonth) )));
        this.editConstants = this.editConstants.map(constant => {
          constant.value = constant.values[selectedMonth].value;
          constant.value_id = constant.values[selectedMonth].id;
          return constant;
        });

        this.editConstants.forEach(constant => {
          this.$set(constant, 'errors', {
            name: false,
            short_name: false,
            value: false,
          });
        });

        this.editConstantsBackup = JSON.parse(JSON.stringify(this.editConstants));

        this.isEditConstantsOpen = true;
      },
      addNewConstant() {
        this.editConstants.push({
          value: null,
          name: "",
          short_name: "",
          code: null,
          errors: {
            name: false,
            short_name: false,
            value: false,
          }
        });
      },
      deleteEditConstant(index, constant){
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Подтверждение',
          text: 'Вы уверены что хотите удалить константу?',
          acceptText: 'Удалить',
          cancelText: 'Отменить',
          parent: this.$refs.editConstantPopup.$el,
          accept: async () => {
            if(constant.value_id){
              this.deleteConstantsArray.push(constant.value_id);
            }

            this.editConstants.splice(index,1);
          }
        });
      },
      async saveConstants() {
        let constantsNeedToUpdate = [];
        let hasErrors = false;
        this.editConstants.forEach(constant => {
          let needToUpdate = false;

          if(constant.value_id){
            let oldConstant = this.editConstantsBackup.find(oldConstant => oldConstant.value_id === constant.value_id);
            if(oldConstant && (oldConstant.name !== constant.name || oldConstant.short_name !== constant.short_name || oldConstant.value !== constant.value)){
              needToUpdate = true;
            }
          }
          else{
            needToUpdate = true;
          }

          if(!constant.name.trim().length){
            constant.errors.name = true;
            hasErrors = true;
          }

          if(!constant.short_name.trim().length){
            constant.errors.short_name = true;
            hasErrors = true;
          }

          if(constant.value === '' || isNaN(parseFloat(constant.value))){
            constant.errors.value = true;
            hasErrors = true;
          }

          if(needToUpdate) constantsNeedToUpdate.push(constant);
        });

        if(!hasErrors){
          await Promise.all(constantsNeedToUpdate.map(async constant => {
            constant.month = this.$options.filters.moment(this.editConstantsMonth, "YYYY-MM");

            if(constant.value_id){
              await this.updateConstant(constant);
            }
            else{
              await this.createConstant(constant);
            }
            return true;
          }));

          await Promise.all(this.deleteConstantsArray.map(async id => {
            await this.deleteConstant(id);
            return true;
          }));

          this.$emit('updateConstants');
          this.isEditConstantsOpen = false;
        }
      },

      createConstant(constant) {
        return new Promise(async (resolve, reject) => {
          try {
            let body = {
              value: constant.value,
              name: constant.name,
              short_name: constant.short_name,
              buildings_id: this.selectedHouseId,
              purpose: "formula",
              month: constant.month
            };

            if(constant.code){
              body.code = constant.code;
              body.types_id = constant.types_id;
            }
            else{
              body.types_id = 5;
            }

            let {data} = await this.$http.post('constants', body);
            resolve(data);
          } catch (e) {
            reject(e);
          }
        })
      },
      updateConstant(constant) {
        return new Promise(async (resolve, reject) => {
          try {
            let body = {
              value: constant.value,
              name: constant.name,
              short_name: constant.short_name,
              buildings_id: this.selectedHouseId,
              id: constant.value_id
            };
            let {data} = await this.$http.put('constants/'+constant.value_id, body);
            resolve(data);
          } catch (e) {
            reject(e);
          }
        })
      },
      deleteConstant(id) {
        return new Promise(async (resolve, reject) => {
          try {
            await this.$http.delete('constants/'+id, {params: {buildings_id: this.selectedHouseId}});
            resolve(true);
          } catch (e) {
            reject(e);
          }
        })
      },

      setExistingValue(newVal, constant){
        if(newVal === null){
          constant.name = null;
          constant.short_name = null;
          constant.value = null;
        }
        else{
          Object.assign(constant,newVal);
        }
      },
      focusSelect(){
        this.updateEditConstantsAll();
        this.$refs.vSelect.forEach(vSelect => {
          this.$nextTick(() => {
            let vSelectElement = vSelect.$el;
            let menu = vSelectElement.querySelector('.vs__dropdown-menu');

            if(!menu) return false;
            let input = vSelectElement.querySelector('.vs__dropdown-toggle');

            let inputPosition = input.getBoundingClientRect();
            menu.style.position = 'fixed';
            menu.style.width = `${inputPosition.width}px`;
            menu.style.top = `${inputPosition.top + inputPosition.height}px`;

            if(window.innerHeight <= inputPosition.top + inputPosition.height + 350 + 10){
              menu.style.maxHeight = `calc(100vh - ${inputPosition.top + inputPosition.height + 10}px)`;
            }
            else{
              menu.style.maxHeight = '350px';
            }
            menu.style.left = `${inputPosition.left}px`;
          });
        });
      },
      updateEditConstantsAll(){
        this.editConstantsAll = this.constants.filter(constant => {
          return [3,5].includes(constant.types_id) && this.editConstants.findIndex(c => c.code === constant.code) === -1
        });
      }

    },
    watch: {
      activeLocal() {
        if (this.activeLocal) {
          this.updateFormula();
          this.$refs.formulaText.focus();
        }

      },
      editConstantsMonth(){
        this.openEditConstant();
        this.updateEditConstantsAll();
      }
    }
  }
</script>

<style lang="scss">
  .formula {
    &__wrapper {
      position: relative;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .125);
      border: 1px solid #d8d8d8;
    }

    &__text {
      opacity: 0;
      color: transparent;
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      text-indent: -10000px;
      z-index: 20;
      /*font-size: 0;*/
    }

    &__container {
      padding: 40px 10px;
      cursor: text;
      position: relative;
      line-height: 2.8;
      background-color: #f2f2f2;
      /*height: 150px;*/
      word-break: break-word;
    }

    &__alert {
      position: absolute;
      width: 200px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #777777;
      box-sizing: border-box;
      border: 1px solid #d8d8d8;
      border-top: 2px solid #ababab;
      border-right: 0;
      background-color: #fafafa;
      text-align: center;
      top: 0;
      right: 1px;
      z-index: 10;

      &_good {
        color: #88ccab;
        border-top-color: #88ccab;
      }

      &_error {
        color: #ff9090;
        border-top-color: #ff9090;
      }
    }

    &__item {
      display: inline;
      vertical-align: middle;
      padding: 4px 10px;
      word-break: break-all;
      margin: 3px;
      background-color: #ffffff;
      border-radius: 999px;
      color: #333333;
      position: relative;
      overflow: hidden;
      white-space: nowrap;
    }

    &__operator {
      color: #f6474e;
    }

    &__bracket {
      background-color: transparent;
      color: #12c2b7;
      margin-left: 0;
      margin-right: 0;
    }

    &__buttons {
      margin-top: 1.5rem;
    }

    &__button {
      flex: 1;
      padding: 5px;

    }

    &__cursor {
      display: inline-block;
      vertical-align: middle;
      height: 16px;
      width: 3px;
      background-color: rgba(0, 0, 0, 0.6);
      animation: blink .5s ease alternate infinite;
    }

    .formula-button {
      &__text {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        background: #f2f2f2;
        color: #333333;
        border-radius: 5px;
        width: 50px;
        height: 50px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, .125);
        border: 1px solid #d8d8d8;
        user-select: none;
        cursor: pointer;
      }

      &_zero {
        .formula-button__text {
          width: 170px;
        }
      }

      &_comma {
        .formula-button__text {
          width: 110px;
        }
      }

    }

    .button-constant {
      padding: 5px;
      display: inline-block;

      &__text {
        display: flex;
        text-align: center;
        justify-content: center;
        background: #f2f2f2;
        color: #333333;
        border-radius: 999px;
        padding: 5px 15px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, .125);
        border: 1px solid #d8d8d8;
        user-select: none;
        cursor: pointer;
      }
    }

    &__number-buttons {
      display: flex;
      align-items: center;
      /*flex: 1 1 80%;*/
    }

    &__operator-buttons {
      display: flex;
      align-items: center;
    }

    &_division_zero {
      text-align: center;
      margin: 5px 0 15px;
      font-size: 0.8rem;
    }

  }

  @keyframes blink {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .formula-popup {
    .vs-popup {
      width: 900px;
    }
  }

  .edit-constant-popup {
    /*z-index: 9999999999;*/

    .vs-popup {
      width: 800px;
    }
  }

  .constants-collapse{
    padding: 0;

    .vs-collapse-item--header{
      font-size: 1rem;
      font-weight: 500;
      padding: 10px;
    }

    .con-content--item{
      padding: 5px 5px 10px!important;
    }
  }

  .edit-constant__name-select{
    min-width: 280px;
    .vs__selected{
      font: 400 11px system-ui;
      font-size: 1rem;
    }

    .vs__dropdown-toggle{
      height: 38px;
    }

    .vs__clear{
      width: 16px;
      height: 16px;
      margin-right: 4px;

      svg{
        width: 100%;
        height: 100%;
      }
    }

    .vs__open-indicator{
      width: 16px;
      height: 16px;

      svg{
        width: 100%;
        height: 100%;
      }
    }
  }
</style>